<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="canEnglishTestForm" (change)="canEnglishTestFormChange()" (submit)="canEnglishTestFormSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">
                    {{"MOODEL_TEST_TITLE" | translate | titlecase }}
                </h6>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row justify-content-center">

                            <!-- <div class="col-md-8 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                    <h5 class="font-bold m-0">{{(globals.lang == 'en')? candNameEn:candNameAr}} - {{candCode}} -
                                        {{candNatId}}</h5>
                                    <img src="assets/images/stud-image.png" class="img-fluid" width="70" id="userImageTag">
                                </div> -->
                            <div class="img-with-text">
                                <img src="{{ photoPath}}" onerror="this.src ='assets/images/stud-image.png';"
                                    alt="Photo" class="img-fluid" width="100" id="userImageTag">
                                <!-- <img src="assets/images/stud-image.png" class="img-fluid" width="100" id="userImageTag"> -->
                                <p style="font-weight: bold;font-size: 16px">
                                    {{"CANDIDATE_NAME" | translate | titlecase}}: &nbsp; &nbsp;{{((globals.lang ==
                                    'en')? candNameEn:candNameAr)}} <br /><br />
                                    {{"CANDUDATE_CODE" | translate | titlecase}}: &nbsp; &nbsp; {{ candCode}}
                                    <br /><br />
                                    {{"NATIONAL_ID" | translate | titlecase}}: &nbsp; &nbsp;{{ candNatId}}<br /><br />
                                </p>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"THANAWEYA_AMA" | translate | titlecase }}</label>
                                <input type="number" class="form-control" value="" formControlName="thanaweyaAma">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="canEnglishTestForm.controls.thanaweyaAma.touched && canEnglishTestForm.controls.thanaweyaAma.invalid && canEnglishTestForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CEFR" | translate  }}</label>
                                <input type="text" class="form-control" value="" formControlName="cefr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="canEnglishTestForm.controls.cefr.touched && canEnglishTestForm.controls.cefr.invalid && canEnglishTestForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"RN" | translate | titlecase }}</label>
                                <input type="number" class="form-control" value="" formControlName="rn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="canEnglishTestForm.controls.rn.touched && canEnglishTestForm.controls.rn.invalid && canEnglishTestForm.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ENGLISH_REPORT" | translate | titlecase }}.</label>
                                <input type="file" class="form-control" formControlName="englishReport" accept=".pdf"
                                    (change)="changeFile($event)">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="canEnglishTestForm.controls.englishReport.touched && canEnglishTestForm.controls.englishReport.invalid && canEnglishTestForm.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="ieltsFilename.length > 0">
                            <div class="col-md-8 form-group px-md-5 mb-4">
                                <!-- <label class="text-bold font-14">{{ "IELTS" | translate | titlecase }}</label> -->
                                <p class="cand-answer"><a href="{{ieltsFilename }}" target="_blank">{{ "VIEW" |
                                        translate | titlecase }}</a></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                                    routerLink="/admission/candidate-inquiry" *ngIf="!creating">
                                    {{"CANCEL" | translate | titlecase}}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - MOODLE-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{"SAVE" | translate | titlecase}}</button>
                                <app-loader [show]="creating"></app-loader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<app-loader [attr.show]="showLoader"></app-loader>